// extracted by mini-css-extract-plugin
export default {"answerInput":"short-answer_answerInput__Qx9fm","characterCount":"short-answer_characterCount__+ELfZ"};